import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { InfoTableConfig } from '../shared.interface';
import { KeyValue } from '@angular/common';
import { SharedService } from '../../e-met/services/shared.service';

@Component({
    selector: 'app-cadastre-attachment-table',
    templateUrl: './cadastre-attachment-table.component.html',
    styleUrls: ['./cadastre-attachment-table.component.scss'],
})
export class CadastreAttachmentTableComponent implements OnInit {
    @Input() tableData: any;

    tablePatern;
    tableName;

    originalOrder = (
        a: KeyValue<number, string>,
        b: KeyValue<number, string>
    ): number => {
        return 0;
    };

    constructor(private sharedService: SharedService) {}

    ngOnInit(): void {
        this.tablePatern = this.tableData?.infoTableData[0]?.data[0];
        this.tableName = this.tableData?.infoTableData[0]?.tableName;

        if (this.tableName === 'documentsTable') {
            console.log(this.tableData)
            this.sharedService.AttachmentsListSubmitter$.subscribe((status) => {
                if (status.submit == true) {
                    this.submitAttachments(status.panelID);
                }
            });
        }
    }

    submitAttachments(panelID) {
        let attachmentObject = [];
        let panel = document.getElementById('panel' + panelID);
        let table = panel.querySelector('.documentsTable tbody');
        let rows = table.querySelectorAll('tr');
        rows.forEach((element) => {
            attachmentObject.push({
                documentId: (<HTMLInputElement>(
                    element.querySelector('input[name=docId]')
                )).value,
                // todo should be dynamic
                documentTypeId: '10',
                documentComments: 'ΚΗΔ',
                panelID: panelID,
            });
            this.sharedService.updateAttachmentsListData(attachmentObject);
        });
    }

    onUploadCheck(event) {
      //console.log(event.checked);
      let panels = document.querySelectorAll('.accordionPanel');
      panels.forEach((panel) => {
        //DocumentsTABLE
        let documentsTable = panel.querySelector('.documentsTable');
        let documentsInputs = documentsTable.querySelectorAll('input');
        documentsInputs.forEach((element) => {
          //console.log('element.name = ', element.name);
          //console.log('element.value = ', element.value);
          if (element.name === 'docId')
            element.value = '';
        });
      });
    }
}
